module.exports = __webpack_public_path__ + "img/close.4e2264b5.svg";